import styled from "styled-components";

const Form = styled.form<{ $open?: boolean }>`
  background: ${props => (props?.$open ? props.theme.colors.redesign.db1 : props.theme.colors.white)};
  overflow: hidden;
  border: none;
  border-bottom-left-radius: ${props => props.theme.borderRadius.basic};
  border-bottom-right-radius: ${props => props.theme.borderRadius.basic};
  display: flex;
  flex: 1;
  box-sizing: border-box;
  min-height: calc(100% - 46px);
`;

const StyledCol = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
`;

const ContentWrapper = styled.div`
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  ${props => props.theme.belowBreakpoint} {
    min-height: 100%;
  }
`;

export { Form, StyledCol, ContentWrapper };
